<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>

        <v-layout row wrap justify-space-between>
          <v-flex>
            <div class="center">
              <v-card outlined>
                <v-card-text class="black--text font-weight-bold">
                  Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique no link a seguir: <a href="https://ods.ufes.br/" target="_blank">UFES - Objetivos de Desenvolvimento Sustentável</a>.
                </v-card-text>
              </v-card>
            </div>
          </v-flex>
        </v-layout>

        <p class="mt-3"></p>

        <v-layout v-for="(lista, index) in this.listaTipoClassificacao" :key="lista[0].tipoClassificacao" row wrap justify-space-between>
          <v-flex>
            <v-text-field v-if="lista[0].classificacaoItem === 90 || lista[0].classificacaoItem === 91 || desabilitaClassificacoes(lista[0].classificacaoItem)"
              :label='lista[0].tipoClassificacao'
              v-model="listaClassificacoesDoProjeto[index].descricao"
              prepend-icon="dashboard"
              readonly
              max-height="400">
            </v-text-field>
            <v-select v-else
              :label="lista[0].tipoClassificacao"
              :items="lista"
              v-model="listaClassificacoesDoProjeto[index]"
              item-text="descricao"
              item-value="id"
              return-object
              prepend-icon="dashboard"
              max-height="400"
              required
              :readonly="lista[0].classificacaoItem === 90 || lista[0].classificacaoItem === 91 || desabilitaClassificacoes(lista[0].classificacaoItem)"
              autocomplete
              >
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="editarClassificacoes(false)" :disabled="!formularioValido">Salvar</v-btn>
      <v-btn color="primary" text @click="editarClassificacoes(true)" :disabled="!formularioValido">Salvar e Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      teste: [{id: 639}, {id: 653}],
      listaClassificacoesDoProjeto: [],
      listaTipoClassificacao: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ClassificacoesProjeto', params: {idProjeto: this.idProjeto}})
      },
      editarClassificacoes: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando classificações.' })
        projetos.postClassificacoesDoProjeto(this.idProjeto, this.listaClassificacoesDoProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          if (avancar === false) {
            this.$router.push({name: 'ClassificacoesProjeto', params: {idProjeto: this.idProjeto}})
          } else {
            this.$router.push({name: 'EditarExtensao', params: {idProjeto: this.idProjeto}})
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando classificações.' })
        })
      },
      obterClassificacoes: function (itemTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui.splice(atributo, 1, response.data.slice())
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        })
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      },
      desabilitaClassificacoes: function (classificacaoItem) {
        if ((classificacaoItem === 100 || classificacaoItem === 110 || classificacaoItem === 111 || classificacaoItem === 112) && this.projeto.situacao.item !== 15 && this.administrador === false) {
          return true
        } else {
          return false
        }
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações do projeto.' })
      projetos.getClassificacoesDoProjeto(this.idProjeto)
      .then(response => {
        /* Ticket #315808 - Resolução CEPE/UFES nº 127/2025  */
        this.listaClassificacoesDoProjeto = response.data.filter(c => c.classificacaoItem !== 125)
        for (let i = 0; i < this.listaClassificacoesDoProjeto.length; i++) {
          this.listaTipoClassificacao.push([{}])
        }
        for (let e in this.listaClassificacoesDoProjeto) {
          this.obterClassificacoes(this.listaClassificacoesDoProjeto[e].classificacaoItem, this.listaTipoClassificacao, e)
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações do projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.dataInicioFormatada = this.dates.format(this.projeto.dataInicio)
        this.dataConclusaoFormatada = this.dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-classificacao.vue?49f92317